import React, { useState } from 'react';
import { Navigation } from './components/Navigation';
import { NotesInterface } from './components/NotesInterface';
import { ReviewSystem } from './components/ReviewSystem';
// Mock data for demonstration
const initialClasses = [{
  id: 'c1',
  name: 'Biology 101',
  score: 85,
  notes: [{
    id: 'n1',
    title: 'Cell Structure',
    content: 'The cell is the basic structural and functional unit of life. It consists of cytoplasm surrounded by a membrane.',
    score: 90
  }, {
    id: 'n2',
    title: 'Photosynthesis',
    content: 'Photosynthesis is the process by which plants and other organisms convert light energy into chemical energy.',
    score: 80
  }]
}, {
  id: 'c2',
  name: 'History 201',
  score: 72,
  notes: [{
    id: 'n3',
    title: 'World War II',
    content: 'World War II was a global conflict that lasted from 1939 to 1945.',
    score: 72
  }]
}];
export function App() {
  const [classes, setClasses] = useState(initialClasses);
  const [activeClass, setActiveClass] = useState(null);
  const [activeNote, setActiveNote] = useState(null);
  const [isReviewing, setIsReviewing] = useState(false);
  const handleAddClass = className => {
    const newClass = {
      id: `c${Date.now()}`,
      name: className,
      score: 0,
      notes: []
    };
    setClasses([...classes, newClass]);
  };
  const handleAddNote = (classId, noteTitle) => {
    setClasses(classes.map(c => {
      if (c.id === classId) {
        const newNote = {
          id: `n${Date.now()}`,
          title: noteTitle,
          content: '',
          score: 0
        };
        return {
          ...c,
          notes: [...c.notes, newNote]
        };
      }
      return c;
    }));
  };
  const handleUpdateNote = (classId, noteId, content) => {
    setClasses(classes.map(c => {
      if (c.id === classId) {
        return {
          ...c,
          notes: c.notes.map(n => n.id === noteId ? {
            ...n,
            content
          } : n)
        };
      }
      return c;
    }));
  };
  const handleStartReview = () => {
    setIsReviewing(true);
  };
  const handleEndReview = () => {
    setIsReviewing(false);
  };
  return <div className="flex h-screen bg-gray-50" data-id="element-0">
      <Navigation classes={classes} activeClass={activeClass} activeNote={activeNote} onSelectClass={setActiveClass} onSelectNote={setActiveNote} onAddClass={handleAddClass} onAddNote={handleAddNote} data-id="element-1" />
      <main className="flex-1 overflow-auto" data-id="element-2">
        {isReviewing ? <ReviewSystem classes={classes} activeClass={activeClass} activeNote={activeNote} onEndReview={handleEndReview} data-id="element-3" /> : <NotesInterface classes={classes} activeClass={activeClass} activeNote={activeNote} onUpdateNote={handleUpdateNote} onStartReview={handleStartReview} data-id="element-4" />}
      </main>
    </div>;
}